module.exports = __webpack_public_path__ + "img/img-3.c3641675.svg";